/*
 * Copyright (c) 2017 Edelweiss72 GmbH - All Rights Reserved
 * Unauthorized usage or distribution of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 *
 * @author Wladimir Eberts <w.eberts@edelweiss72.de>
 */

(function ($)
{
    $.extend($.fn, {
        ewform()
        {
            if (!this.length)
            {
                return;
            }

            function scrollTo(element, offset = -250, time = 'slow', force = false)
            {
                const settings = {},
                    $elements = $(element);

                let scroll = false;

                if (typeof $.fn.scrollTo === 'undefined')
                {
                    return;
                }

                if (typeof offset !== 'undefined')
                {
                    settings.offset = offset;
                }

                $elements.each(function ()
                {
                    const $element = $(this),
                        bounds = $element.get(0).getBoundingClientRect(),
                        boundsTop = bounds.top;

                    let boundsBottom = bounds.bottom;

                    if (typeof offset !== 'undefined')
                    {
                        // boundsTop += offset;
                        boundsBottom += offset;
                    }

                    if (boundsBottom <= 0 || boundsTop < 0 || boundsTop >= window.innerHeight - 20)
                    {
                        scroll = true;
                    }
                    else
                    {
                        // at least one element is in sight
                        scroll = false;

                        // break each
                        return false;
                    }
                });

                if (force || scroll)
                {
                    $.scrollTo($elements, time, settings);
                }
            }

            function renderBytes(size)
            {
                const units = ['bytes', 'KB', 'MB', 'GB'];

                for (let i = 0; i < units.length; i++)
                {
                    if (size >= 1024)
                    {
                        size /= 1024;
                    }
                    else
                    {
                        return Math.round((size + 0.00001) * 100) / 100 + ' ' + units[i];
                    }
                }

                return 0;
            }

            $(document).on('keydown.tabFocus', (event) =>
            {
                const $forms = $(this);

                // special care for radio/checkbox
                if ($(document.activeElement).is(':radio, :checkbox'))
                {
                    // we only care about the tab key, space or arrow keys
                    if ($.inArray(event.which, [9, 32, 37, 38, 39, 40]) === -1)
                    {
                        return;
                    }
                }

                // we only care about the tab key
                else if (event.which !== 9)
                {
                    return;
                }

                $forms.addClass('is-tab-focus');

                $(document).on('click.tabFocus touchstart.tabFocus', (event) =>
                {
                    // this is a fake click event
                    if ($(document.activeElement).is(':radio, :checkbox') && !event.clientX && !event.clientY)
                    {
                        return;
                    }

                    $forms.removeClass('is-tab-focus');

                    $(document).off('click.tabFocus touchstart.tabFocus');
                });
            });

            this.each(function ()
            {
                const
                    $form = $(this),
                    $depends = $form.find('[data-depends]'),
                    $dynamics = $form.find('[data-dynamic]'),
                    inputsSelector = '.m-input :input';

                let isSubmit = false,
                    $inputs = $form.find(inputsSelector);

                $form.wrapInner('<fieldset></fieldset>');

                $form.append('<div class="m-spinner">' + (new Array(16 + 1).join('<span></span>')) + '</div>');

                $form.on('focusin.states focusout.states', inputsSelector, function (event)
                {
                    const $parents = $(this).parentsUntil($form).add($form);

                    if (event.type === 'focusin')
                    {
                        $parents.addClass('is-focus');
                    }
                    else
                    {
                        $parents.removeClass('is-focus');
                    }
                });

                $form.on('change.states blur.states input.states', inputsSelector, function()
                {
                    const $input = $(this),
                        $field = $input.closest('.m-field');

                    if ($input.is(':radio, :checkbox'))
                    {
                        $field.toggleClass('is-checked', $input.is(':checked'));

                        return;
                    }

                    let value = $input.val();

                    $field.toggleClass('is-filled', value !== '');

                    if ($input.is('select'))
                    {
                        $field.toggleClass('is-placeholder', value === '' && $input.find('option:selected').text().trim().length > 0);
                    }
                    else if ($input.is('[type="date"]'))
                    {
                        $field.addClass('is-placeholder');
                    }
                    else if ($input.is('[placeholder]'))
                    {
                        const ie = S.ie();

                        if (ie && ie <= 11)
                        {
                            $field.toggleClass('is-placeholder', $input.is(':-ms-input-placeholder'));
                        }
                        else if (ie && ie <= 18)
                        {
                            $field.toggleClass('is-placeholder', value === '');
                        }
                        else
                        {
                            $field.toggleClass('is-placeholder', $input.is(':placeholder-shown'));
                        }
                    }
                });

                if (typeof $.fn.fineUploader !== 'undefined')
                {
                    const $fineUploaders = $form.find('.m-input .m-fineuploader');

                    $inputs = $inputs.add($fineUploaders);

                    $fineUploaders.each(function ()
                    {
                        let lastError = null,
                            initalValidate = false;

                        const
                            $fineUploader = $(this),
                            settings = $fineUploader.data('settings');

                        $fineUploader
                            .fineUploader({
                                template: $fineUploader.find('.qq-template'),
                                request: {
                                    endpoint: settings.endpoint,
                                },
                                retry: {
                                    enableAuto: true,
                                },
                                session: {
                                    endpoint: settings.endpoint,
                                },
                                validation: {
                                    itemLimit: settings.maxfiles,
                                    sizeLimit: settings.maxlength,
                                    minSizeLimit: settings.minlength,
                                    allowedExtensions: settings.accept,
                                },
                                deleteFile: {
                                    enabled: true,
                                    method: 'POST',
                                    endpoint: settings.endpoint,
                                },
                                text: {
                                    fileInputTitle: '',
                                },
                                messages: {
                                    typeError: 'Die ausgewählten Dateiformate sind nicht zulässig. Bitte wähle Dateien im Format {extensions} aus.',
                                    sizeError: 'Datei zu groß. Bitte wähle eine andere aus.',
                                    minSizeError: '{file} is too small, minimum file size is {minSizeLimit}.',
                                    emptyError: 'Datei ist leer. Bitte wähle eine andere aus.',
                                    noFilesError: 'Es wurden keine Dateien ausgewählt.',
                                    tooManyItemsError: 'Bitte wähle maximal {itemLimit} Dateien aus.',
                                    maxHeightImageError: 'Image is too tall.',
                                    maxWidthImageError: 'Image is too wide.',
                                    minHeightImageError: 'Image is not tall enough.',
                                    minWidthImageError: 'Image is not wide enough.',
                                    retryFailTooManyItems: 'Retry failed - you have reached your file limit.',
                                    onLeave: 'The files are being uploaded, if you leave now the upload will be canceled.',
                                    unsupportedBrowserIos8Safari: 'Unrecoverable error - this browser does not permit file uploading of any kind due to serious bugs in iOS8 Safari.  Please use iOS8 Chrome until Apple fixes these issues.',
                                },
                                thumbnails: {
                                    timeBetweenThumbs: 0,
                                    placeholders: {
                                        waitUntilResponse: true,
                                        waitingPath: '/assets/img/fineuploader-preview.jpg',
                                        notAvailablePath: '/assets/img/fineuploader-preview.jpg',
                                    },
                                },

                                showMessage() {},
                            })
                            .on('error', (event, id, name, errorReason) =>
                            {
                                lastError = errorReason;
                            })
                            .on('submit', () =>
                            {
                                initalValidate = true;
                            })
                            .on('allComplete', () =>
                            {
                                // validate
                                $fineUploader.trigger('change');
                            })
                            .on('deleteComplete', () =>
                            {
                                // validate
                                $fineUploader.trigger('change');
                            })
                            .on('validate', () =>
                            {
                                if (initalValidate)
                                {
                                    initalValidate = false;

                                    return true;
                                }

                                if (lastError)
                                {
                                    const temp = lastError;

                                    lastError = null;

                                    return temp;
                                }

                                const netUploads = $fineUploader.fineUploader('getNetUploads');

                                // hide upload button if max. files reached
                                $fineUploader.find('.m-upload-button-wrapper').toggle(netUploads < settings.maxfiles);

                                // require at least one file
                                if ($fineUploader.is('[required]') && !netUploads)
                                {
                                    return 'required';
                                }

                                return true;
                            });
                    });
                }

                // input validation
                $form.on('change blur input', inputsSelector, function (event, time, isInit)
                {
                    let error = false,
                        valid = false,
                        $input = $(this),
                        value = $input.val();

                    const $inputSingle = $input;

                    if ($input.prop('disabled'))
                    {
                        return;
                    }

                    if (!$input.parent().is(':visible'))
                    {
                        return;
                    }

                    if ($input.parentsUntil($form, '.m-field').hasClass('is-dependent'))
                    {
                        return;
                    }

                    // radio
                    if ($input.is('[required]:radio'))
                    {
                        let $radios = $input.data('form-radios');

                        // cache
                        if (!$radios)
                        {
                            $radios = $inputs.filter(':radio[name="' + $input.attr('name') + '"]:visible');
                            $radios.data('form-radios', $radios);
                        }

                        // first includes all multi radios
                        if (isSubmit && $radios.index($input) > 0)
                        {
                            return;
                        }

                        const $radioChecked = $radios.filter(':checked');

                        if (!$radioChecked.length || $radioChecked.val() === '')
                        {
                            error = 'required';
                        }
                        else
                        {
                            valid = true;
                        }

                        $input = $radios;
                    }

                    // checkbox
                    else if ($input.is(':checkbox'))
                    {
                        // multi checkboxes
                        if ($input.parentsUntil($form, '.m-multi-checkbox').length)
                        {
                            let $checkboxes = $input.data('form-checkboxes');

                            // cache
                            if (!$checkboxes)
                            {
                                const $multi = $input.parentsUntil($form, '.m-multi-checkbox').last();

                                $checkboxes = $multi.find('.m-item-checkbox').find(':checkbox:visible');
                                $checkboxes.data('form-checkboxes', $checkboxes);
                            }

                            // first includes all multi checkboxes
                            if (isSubmit && $checkboxes.index($input) > 1)
                            {
                                return;
                            }

                            const checkedCount = $checkboxes.filter(':checked').length;

                            if (!checkedCount && $input.is('[required]'))
                            {
                                error = 'required';
                            }

                            else if (checkedCount || $input.is('[required]'))
                            {
                                if ($input.is('[minlength]') && checkedCount < parseInt($input.attr('minlength'), 10))
                                {
                                    error = 'minlength';
                                }

                                else if ($input.is('[maxlength]') && checkedCount > parseInt($input.attr('maxlength'), 10))
                                {
                                    error = 'maxlength';
                                }

                                else if (checkedCount)
                                {
                                    valid = true;
                                }
                            }

                            $input = $checkboxes;
                        }

                        // single checkbox
                        else if ($input.is('[required]') && !$input.is(':checked'))
                        {
                            error = 'required';
                        }

                        else if ($input.is('[required]:checked'))
                        {
                            valid = true;
                        }
                    }

                    // general
                    else
                    {
                        const custom = $input.triggerHandler('validate', [value]);

                        // standard validation
                        if (typeof custom === 'undefined')
                        {
                            if ($input.is('.filepond--browser'))
                            {
                                const filepond = $input.data('filepond');

                                if (filepond)
                                {
                                    switch (filepond.status)
                                    {
                                        case 0 /*EMPTY*/:
                                            if (!isInit && $input.hasClass('is-required'))
                                            {
                                                error = 'required';
                                            }
                                            break;

                                        case 1 /*IDLE*/:
                                            break;

                                        case 2 /*ERROR*/:
                                            error = 'error';
                                            break;

                                        case 3 /*BUSY*/:
                                            error = 'busy';
                                            break;

                                        case 4 /*READY*/:
                                            valid = true;
                                            break;
                                    }
                                }
                            }

                            else if ($input.is('[name="g-recaptcha-response"]') && !value.length && $input.closest('[data-sitekey]').is(':not([data-size="invisible"]')) {
                                error = 'required';
                            }

                            else if ($input.is('[required]') && (!value.length || (typeof value === 'string' && !value.match(/\S+/))))
                            {
                                error = 'required';
                            }

                            else if (value.length || $input.is('[required]'))
                            {
                                if ($input.is('[type=file]'))
                                {
                                    // remove path (some browsers use c:\fake\ etc.)
                                    value = value.replace(/^.*[\\/]/, '');

                                    $input.parent('.m-input').attr('data-filename', value);

                                    // filesize check
                                    if (typeof $input.get(0).files !== 'undefined' && $input.get(0).files.length)
                                    {
                                        const file = $input.get(0).files[0];

                                        let fileSize = file.size;

                                        // multi files
                                        if ($input.parentsUntil($form, '.m-multi-file').length)
                                        {
                                            let $files = $input.data('form-files');

                                            // cache
                                            if (!$files)
                                            {
                                                const $multifile = $input.parentsUntil($form, '.m-multi-file').last();

                                                $files = $multifile.find('.m-item-file').find('[type=file]');
                                                $files.data('form-files', $files);
                                            }

                                            fileSize = 0;

                                            $files.each(function ()
                                            {
                                                if (this.files.length)
                                                {
                                                    fileSize += this.files[0].size;
                                                }
                                            });
                                        }

                                        $input.parent('.m-input').attr('data-filesize', renderBytes(fileSize));

                                        if ($input.is('[minlength]') && fileSize < parseInt($input.attr('minlength'), 10))
                                        {
                                            error = 'minlength';
                                        }

                                        else if ($input.is('[maxlength]') && fileSize > parseInt($input.attr('maxlength'), 10))
                                        {
                                            error = 'maxlength';
                                        }
                                    }

                                    if (!error && $input.is('[accept]'))
                                    {
                                        const accept = $input.attr('accept'),
                                            pattern = /(?:^|,)\s*\.([^.,\s]+)/g;

                                        let match,
                                            matchCount = 0;

                                        while ((match = pattern.exec(accept)) !== null)
                                        {
                                            if (value.match(new RegExp(`.${match[1]}$`, 'i')))
                                            {
                                                matchCount++;
                                                break;
                                            }
                                        }

                                        if (!matchCount)
                                        {
                                            error = 'accept';
                                        }
                                    }

                                    if (!error && $input.is('[pattern]') && !value.match(new RegExp($input.attr('pattern'))))
                                    {
                                        error = 'pattern';
                                    }

                                    else if (!error)
                                    {
                                        valid = true;
                                    }
                                }

                                else if ($input.is('[minlength]') && value.length < parseInt($input.attr('minlength'), 10))
                                {
                                    error = 'minlength';
                                }

                                else if ($input.is('[maxlength]') && value.length > parseInt($input.attr('minlength'), 10))
                                {
                                    error = 'maxlength';
                                }

                                else if ($input.is('[pattern]') && !value.match(new RegExp($input.attr('pattern'))))
                                {
                                    error = 'pattern';
                                }

                                else if ($input.is('[data-match]') && value !== $($input.attr('data-match')).val())
                                {
                                    error = 'match';
                                }

                                else
                                {
                                    valid = true;
                                }
                            }

                            else if ($input.is('[type=file]'))
                            {
                                $input.parent('.m-input').attr('data-filename', '').attr('data-filesize', '');
                            }
                        }

                        // custom validation
                        else if (custom === true)
                        {
                            valid = true;
                            error = false;
                        }

                        // custom validation: error
                        else
                        {
                            error = custom;
                            valid = false;
                        }
                    }

                    if (error === 'required' && $input.is('.is-dependent'))
                    {
                        error = false;
                    }

                    // PHP validation triggered the error
                    if (isInit && $input.hasClass('is-error'))
                    {
                        const $error = $input.parentsUntil($form, '.m-field').add($form).find('.m-error:first').last();

                        $input.data('error-message', $error.find('> ul > li'));

                        return;
                    }

                    let messageParent = false;

                    // hide error message
                    if (error === false)
                    {
                        const $error = $input.data('error-message');

                        if ($error)
                        {
                            const errorCount = ($error.data('error-count') || 0) - 1;

                            $error.data('error-count', errorCount);

                            if (errorCount <= 0)
                            {
                                $error.fadeOut(function ()
                                {
                                    $error.remove();
                                });
                            }

                            $input.removeData('error-message');
                        }
                    }

                    // show error message
                    else
                    {
                        let message = error;

                        let $error = $input.data('error-message');

                        // get error message
                        let messages = $input.data('errors');

                        if (messages && !messages[error])
                        {
                            if (messages[error] === false)
                            {
                                message = null;
                            }
                            else
                            {
                                messages = null;
                            }
                        }
                        else if (messages && messages[error] === 'parent')
                        {
                            messages = null;
                            messageParent = true;
                        }

                        // quick hack: clean up
                        if ($error)
                        {
                            const isParentError = $error.parentsUntil($form, '.m-error').get(0) === $form.find('.m-error:first').get(0);
                            const wantParentError = $inputSingle.parentsUntil($form, '.m-field').add($form).find('.m-error:first').get(messageParent ? -2 : -1) === $form.find('.m-error:first').get(0);

                            if (isParentError !== messageParent && isParentError !== wantParentError)
                            {
                                const errorCount = ($error.data('error-count') || 0) - 1;

                                $error.data('error-count', errorCount);

                                if (errorCount <= 0)
                                {
                                    $error.remove();
                                }

                                $input.removeData('error-message');

                                $error = null;
                            }
                        }

                        if (!messages)
                        {
                            messages = $input.parent().closest('[data-errors]').data('errors');
                        }

                        if (messages && messages[error])
                        {
                            message = messages[error];

                            const $label = $inputSingle.parentsUntil($form, '.m-field').children('.m-inner').children('.m-label:visible:first').last();

                            message = message.replace(/{{(\S+)}}/g, function (match, key)
                            {
                                let value;

                                if (key === 'name')
                                {
                                    return $inputSingle.attr('name');
                                }
                                else if (key === 'label')
                                {
                                    return $label.length ? $label.clone().children().remove().end().text() : $inputSingle.attr('name');
                                }
                                else if (key === 'minlength')
                                {
                                    value = parseInt($inputSingle.attr('minlength'), 10);

                                    if ($input.is('[type=file]'))
                                    {
                                        value = renderBytes(value);
                                    }

                                    return value;
                                }
                                else if (key === 'maxlength')
                                {
                                    value = parseInt($inputSingle.attr('maxlength'), 10);

                                    if ($input.is('[type=file]'))
                                    {
                                        value = renderBytes(value);
                                    }

                                    return value;
                                }
                                else if (key === 'match')
                                {
                                    const $match = $($inputSingle.attr('data-match')),
                                        $matchLabel = $match.parentsUntil($form, '.m-field').children('.m-label:visible:first').last();

                                    return $matchLabel.length ? $matchLabel.clone().children().remove().end().text() : $match.attr('name');
                                }

                                return match;
                            });
                        }

                        if (message !== null)
                        {
                            // error message already available
                            if ($error)
                            {
                                $error.html(message);
                            }

                            // add new error message
                            else
                            {
                                $error = $inputSingle.parentsUntil($form, '.m-field').add($form).find('.m-error:first').eq(messageParent ? -2 : -1);

                                if ($error.length)
                                {
                                    if ($error.children('ul').length === 0)
                                    {
                                        $error = $('<ul></ul>').appendTo($error);
                                    }
                                    else
                                    {
                                        $error = $error.children('ul');
                                    }

                                    const $line = $('<li>' + message + '</li>').appendTo($error).hide().fadeIn().data('error-input', $inputSingle).data('error-count', 1);

                                    // remove duplicates
                                    $error.children('li').each(function ()
                                    {
                                        const $li = $(this);

                                        if ($li.is($line))
                                        {
                                            return;
                                        }

                                        if ($li.text() === $line.text())
                                        {
                                            const
                                                errorCount = ($line.data('error-count') || 0) + 1,
                                                $errorInput = $li.data('error-input');

                                            if ($errorInput)
                                            {
                                                $errorInput.data('error-message', $line);
                                            }

                                            $li.remove();
                                            $line.data('error-count', errorCount);
                                        }
                                    });

                                    $input.data('error-message', $line);
                                }
                            }
                        }
                    }

                    $input
                        .toggleClass('is-error', error !== false)
                        .toggleClass('is-valid', !isInit && valid === true)
                        .trigger('change.dependency');

                    // parents (only known classes, to match server-side)
                    const $parents = $input.parentsUntil($form, '.m-group, .m-field, .m-multi, .m-item, .m-input').add($form);

                    $parents.each(function ()
                    {
                        const $parent = $(this),
                            hasError = ($parent.find('input.is-error, textarea.is-error, select.is-error, .m-fineuploader.is-error').length > 0);

                        $parent
                            .add($parent.children('.m-label'))
                            .toggleClass('is-error', hasError)
                            .toggleClass('is-valid', !isInit && !hasError && (valid === true));
                    });
                });

                // dependencies
                $depends.each(function ()
                {
                    const $depend = $(this),
                        $dependents = $($depend.data('depends').join(','));

                    $inputs = $inputs.add($dependents);

                    // $depend.find(':input').prop('disabled', true);
                    $depend.addClass('is-dependent').find('*').not('[data-depends]').addClass('is-dependent');

                    $dependents.on('change.dependency blur input', function (event, isMultiple)
                    {
                        const $input = $(this);

                        // delay for radio buttons
                        if (event.type === 'blur' && $input.is(':radio'))
                        {
                            setTimeout(function ()
                            {
                                $input.trigger('change.dependency');
                            }, 250);

                            return;
                        }

                        if ($input.is('.is-error') || (!$input.is('div') && !$input.val().length) || ($input.is('.m-fineuploader') && !$input.fineUploader('getNetUploads')) || ($input.is('.filepond--root') && !$input.filepond('getFiles').length) || $input.is(':radio:not(:checked), :checkbox:not(:checked)'))
                        {
                            // $depend.find(':input').prop('disabled', true);
                            $depend.addClass('is-dependent').find('*').not('[data-depends]').addClass('is-dependent');

                            $depend.find('*').add($depend).removeClass('is-error');

                            $depend.find($inputs).each(function ()
                            {
                                const $input = $(this),
                                    $error = $input.data('error-message');

                                if ($error)
                                {
                                    $error.fadeOut(function ()
                                    {
                                        $error.remove();
                                    });

                                    $input.removeData('error-message');
                                }
                            });

                            if (!isMultiple && $dependents.length > 1)
                            {
                                $dependents.not($input).trigger('change.dependency', [true]);
                            }
                        }
                        else if ($input.val().length || ($input.is('.m-fineuploader') && $input.fineUploader('getNetUploads') > 0)  || ($input.is('.filepond--root') && $input.filepond('getFiles').length > 0) || $input.is(':checked'))
                        {
                            // $depend.find(':input').prop('disabled', false);
                            $depend.removeClass('is-dependent').find('*').not('[data-depends]').removeClass('is-dependent');
                        }
                    });
                });

                // initialize states
                $inputs.trigger('change.states');

                // initialize dependencies
                $inputs.each(function ()
                {
                    const $input = $(this);

                    if ($input.is(':radio, :checkbox'))
                    {
                        if ($input.is(':checked') && $input.val() !== '')
                        {
                            $input.trigger('change', [0, true]);
                        }
                    }
                    else if ($input.val().length || $input.hasClass('is-error'))
                    {
                        $input.trigger('change', [0, true]);
                    }
                });

                $inputs.filter('[type=file]').on('change blur input', function ()
                {
                    const $input = $(this);

                    let $button = $input.next('.m-clear');

                    if ($input.val() === '')
                    {
                        $button.remove();
                    }
                    else if (!$button.length)
                    {
                        $button = $('<span class="m-clear"></span>')
                            .on('click', function ()
                            {
                                $input.val('').trigger('change');
                                $button.remove();
                            })
                            .insertAfter($input);
                    }
                });

                // initially scroll to first error
                if ($form.find('.m-item .is-error').length > 0)
                {
                    setTimeout(function ()
                    {
                        scrollTo($form.find('.m-field.is-error').first());
                    }, 250);
                }

                $form.find('[data-match]').on('paste', function (event)
                {
                    event.preventDefault();
                });

                // captcha image
                $form.find('.m-input-captcha--image .js-reload').on('click', function ()
                {
                    const $wrapper = $(this).parentsUntil($form, '.m-input'),
                        $captcha = $wrapper.find('.m-captcha'),
                        $input = $wrapper.find('input');

                    $captcha.attr('src', $captcha.attr('src').replace(/(captcha\d+=)\d+/, '$1' + Math.floor(Math.random() * 2147483647)));
                    $input.blur().val('').focus();
                });

                // dynamics
                $dynamics.each(function ()
                {
                    const $dynamic = $(this),
                        $siblings = $dynamic.siblings().addBack().addClass('is-dynamic'),
                        maxCounter = $dynamic.data('dynamic'),
                        dynamicName = $dynamic.data('dynamic-name') || 'Eintrag',
                        $removeButton = $('<span class="m-dynamic-remove js-dynamic-remove" title="' + dynamicName + ' löschen">🗙</span>'),
                        $cloneButton = $('<button class="m-dynamic-clone js-dynamic-clone" type="button">' + dynamicName + ' hinzufügen</button>').insertAfter($siblings.last());

                    let counter = $siblings.length,
                        $clones = $();

                    function cloneDelete()
                    {
                        const
                            $button = $(this),
                            $container = $button.parent();

                        if ($container.hasClass('is-deleted'))
                        {
                            $container
                                .removeClass('is-deleted')
                                .find('.js-dynamic-delete').val('');

                            $container
                                .find(':input:not([type="hidden"])').not($button).prop('disabled', false);
                        }
                        else
                        {
                            $container
                                .addClass('is-deleted')
                                .find('.js-dynamic-delete').val('1');

                            $container
                                .find(':input:not([type="hidden"])').not($button).prop('disabled', true);
                        }
                    }

                    $removeButton
                        .on('click', cloneDelete)
                        .appendTo($siblings);

                    $cloneButton
                        .on('click', function ()
                        {
                            if (counter > maxCounter)
                            {
                                return;
                            }

                            const $clone = $dynamic.clone();

                            $clones = $clones.add($clone);

                            $clone.find('.select2-container').remove();

                            $clone
                                .attr('data-dynamic', null)
                                .find('[id], [for], [name]').addBack('[id], [for], [name]')
                                .each(function ()
                                {
                                    const $element = $(this),
                                        oId = $element.attr('id'),
                                        oFor = $element.attr('for'),
                                        oName = $element.attr('name');

                                    $element.prop('value', '');
                                    $element.prop('checked', false);

                                    if (oId)
                                    {
                                        $element.attr('id', oId.replace(/(\d+)$/, function (value)
                                        {
                                            return parseInt(value, 10) + counter;
                                        }));
                                    }

                                    if (oFor)
                                    {
                                        $element.attr('for', oFor.replace(/(\d+)$/, function (value)
                                        {
                                            return parseInt(value, 10) + counter;
                                        }));
                                    }

                                    if (oName)
                                    {
                                        $element.attr('name', oName.replace(/\[(\d+)]/, function (_, value)
                                        {
                                            return '[' + (parseInt(value, 10) + counter) + ']';
                                        }));
                                    }
                                });

                            $clone.find('.js-dynamic-remove').on('click', cloneDelete);

                            $clone.insertBefore($cloneButton);

                            $form.trigger('dynamic', [$clone, $dynamic, counter]);

                            counter++;

                            $inputs = $form.find(inputsSelector);
                        });
                });

                $form
                    .removeClass('no-js')
                    .on('reset', function ()
                    {
                        setTimeout(function ()
                        {
                            $inputs = $form.find(inputsSelector);

                            $form.find('*').add($form).removeClass('is-error is-valid');

                            $inputs
                                .trigger('change.dependency')
                                .each(function ()
                                {
                                    const $input = $(this),
                                        $error = $input.data('error-message');

                                    if ($error)
                                    {
                                        $error.fadeOut(function ()
                                        {
                                            $error.remove();
                                        });

                                        $input.removeData('error-message');
                                    }
                                });

                            $inputs.filter('[type=file]').parent('.m-input').attr('data-filename', null).attr('data-filesize', null);
                        }, 0);
                    })
                    .on('validate', function ()
                    {
                        $inputs = $form.find(inputsSelector);

                        isSubmit = true;
                        $inputs.trigger('change');
                        isSubmit = false;

                        if ($form.find('.m-item .is-error:visible').length > 0)
                        {
                            scrollTo($form.find('.m-field.is-error:visible').first());

                            return false;
                        }

                        return true;
                    })
                    .on('submit', function ()
                    {
                        $inputs = $form.find(inputsSelector);

                        isSubmit = true;
                        $inputs.trigger('change');

                        // TODO: replace filepond in $inputs
                        $form.find('.filepond--root input[type="file"]').trigger('change');
                        isSubmit = false;

                        if ($form.find('.m-item .is-error:visible').length > 0)
                        {
                            scrollTo($form.find('.m-field.is-error:visible').first());

                            return false;
                        }

                        const $captcha = $form.find('.h-captcha[data-size="invisible"], .g-recaptcha[data-size="invisible"]');

                        if (typeof grecaptcha === 'object' && $captcha.length)
                        {
                            const $captchaResponse = $captcha.find('[name="g-recaptcha-response"]');

                            if (!$captchaResponse.val().length)
                            {
                                grecaptcha.execute();

                                return false;
                            }
                        }

                        const $inputsInactive = $form.find(':input:hidden:not([type="hidden"]):not([name="g-recaptcha-response"])');

                        $inputsInactive.prop('disabled', true);
                    });
            });

            return this;
        },
    });

    $('.mod-form').removeClass('no-js');

    $(function ()
    {
        $('.mod-form').ewform();
    });
})(jQuery);

function formRenderCaptcha()
{
    if (typeof grecaptcha !== 'object')
    {
        return;
    }

    $('.mod-form .h-captcha, .mod-form .g-recaptcha').each(function ()
    {
        var $captcha = $(this),
            $form = $captcha.closest('.mod-form');

        grecaptcha.render(this, {
            callback: function ()
            {
                if ($captcha.is('[type="submit"], [data-size="invisible"]'))
                {
                    $form.submit();
                }
            }
        })
    });
}
